/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CertifyReportCommandResult } from '../../models/certify-report-command-result';
import { ProjectDailyReportStatus } from '../../models/project-daily-report-status';

export interface ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Params {
      body?: {
'Id'?: string;
'Status'?: ProjectDailyReportStatus;
'OwnerNotes'?: string;
'OwnerAttachments'?: Array<Blob>;
}
}

export function apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CertifyReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CertifyReportCommandResult>;
    })
  );
}

apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost.PATH = '/api/ProjectMaintenanceReport/CertifyProjectMaintenanceReport';
